export default __webpack_public_path__ + "static/DPESummit_2025-0ef011c7a8657870e249ade1aa5c0a5b.png";